// слайдеры
const FullSlider = require('./sliders/full-slider');
const VideoSlider = require('./sliders/video-slider');
const ProductSlider = require('./sliders/product-slider');

$(() => {
	FullSlider.init();
	VideoSlider.init();
	ProductSlider.init();
});